const merge = require('webpack-merge')
const localEnv = require('./local.env')

module.exports = merge({
  NODE_ENV: '"production"',
  API_URL: '"production_api_url"',
  SITE_URL: '"production_site_url"',
}, localEnv)



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 179
// module chunks = 1